import { render, staticRenderFns } from "./iconMenu8.vue?vue&type=template&id=535cda89&scoped=true&"
import script from "./iconMenu8.vue?vue&type=script&lang=js&"
export * from "./iconMenu8.vue?vue&type=script&lang=js&"
import style0 from "./iconMenu8.vue?vue&type=style&index=0&id=535cda89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535cda89",
  null
  
)

export default component.exports